module.exports = __webpack_public_path__ + "img/founders_02.162c8543.jpg";